import { ThreeDotsAppLoader } from 'modules/core';
import loadableWithRetry from 'modules/core/components/LoadableWithRetry';

export default loadableWithRetry(
  () =>
    import(
      /* webpackChunkName: "public/welcome" */
      './Login'
    ),
  {
    fallback: <ThreeDotsAppLoader />,
  }
);
